'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

var _viewPromiseModal = require('./viewPromise.modal.html');

var _viewPromiseModal2 = _interopRequireDefault(_viewPromiseModal);

var _lodash = require('lodash');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var PromiseListController = function () {
  function PromiseListController(authService, userService, promiseService, loadingService, addPromiseService, $uibModal, $scope, enums) {
    "ngInject";

    (0, _classCallCheck3.default)(this, PromiseListController);
    this.authService = authService;
    this.userService = userService;
    this.promiseService = promiseService;
    this.loadingService = loadingService;
    this.addPromiseService = addPromiseService;
    this.$uibModal = $uibModal;
    this.$scope = $scope;
    this.enums = enums;

    this.overrideUserId = null;
    this.selectedDate = null;
    this.promises = [];

    this.pagination = {
      totalItems: 0,
      currentPage: 1,
      pageSize: 10
    };

    $scope.$on('dashboard:promisesStats', this.loadStats.bind(this));
    $scope.$on('dashboard:promises', this.listPromises.bind(this));
  }

  (0, _createClass3.default)(PromiseListController, [{
    key: 'loadStats',
    value: function loadStats(evt, params) {
      var ctrl = this;

      ctrl.loadingService.showLoading('promiseList', 'Loading Promises');

      this.overrideUserId = params ? params.userId : null;
      this.selectedDate = params ? params.selectedDate : new Date();

      ctrl.userService.promisesStats(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId, this.selectedDate).then(function (response) {
        ctrl.pagination.totalItems = response.data.item3;
        ctrl.onLoadStats({ dueToday: response.data.item1, overdue: response.data.item2 });
      }).finally(function () {
        ctrl.loadingService.hideLoading('promiseList');
      });
    }
  }, {
    key: 'listPromises',
    value: function listPromises(evt, params) {
      var _this = this;

      //Toggle Event coming from dashboard instead of page change, skip the method
      if (evt && this.promises.length && !params.reload) {
        return;
      }

      var ctrl = this;

      ctrl.loadingService.showLoading('promiseList', 'Loading Promises');

      ctrl.userService.promises(ctrl.authService.authData.currentLocation.key, ctrl.authService.authData.userId, ctrl.authService.isManager(), this.overrideUserId, this.selectedDate, this.pagination.currentPage).then(function (response) {
        _this.promises = response.data;
      }).finally(function () {
        ctrl.loadingService.hideLoading('promiseList');
      });
    }
  }, {
    key: 'showAddPromise',
    value: function showAddPromise(contact) {
      var _this2 = this;

      this.addPromiseService.showAddPromise(function () {
        _this2.listPromises();
      }, null, null, contact, true);
    }
  }, {
    key: 'updateOwner',
    value: function updateOwner(promiseId) {
      var _this3 = this;

      this.addPromiseService.showUpdateOwner(promiseId, function () {
        _this3.listPromises();
      });
    }
  }, {
    key: 'complete',
    value: function complete(addAnother) {
      var ctrl = this;

      var sure = window.confirm('Are you sure you want to complete this promise');

      if (!sure) {
        return;
      }

      ctrl.promiseService.complete(this.selectedPromise.promiseId, this.tempComments).finally(function () {
        ctrl.closeModal();
        ctrl.listPromises();

        if (addAnother) {
          var contact = null;
          if (ctrl.selectedPromise.categoryId === ctrl.enums.PROMISE_CATEGORY.Customer) {
            contact = {
              contactId: ctrl.selectedPromise.contactId,
              contactName: ctrl.selectedPromise.contactName
            };
          }

          ctrl.showAddPromise(contact);
        }
      });
    }
  }, {
    key: 'closeModal',
    value: function closeModal() {
      var ctrl = this;

      if (ctrl.modalInstance) {
        ctrl.modalInstance.close();
      }
    }
  }, {
    key: 'viewPromise',
    value: function viewPromise(promise) {
      this.errMsg = '';
      this.tempComments = '';
      this.selectedPromise = promise;
      this.modalInstance = this.$uibModal.open({
        template: _viewPromiseModal2.default,
        scope: this.$scope
      });
    }
  }, {
    key: 'completePromise',
    value: function completePromise(addAnother) {
      if (!this.tempComments) {
        this.errMsg = "Please enter some comments first";
        return;
      }

      this.complete(addAnother);
    }
  }]);
  return PromiseListController;
}();

exports.default = PromiseListController;


// WEBPACK FOOTER //
// ./client/app/components/promise/promiseList/promiseList.controller.js